export function getSessionSecretKey() {
  return sessionStorage.getItem("sessionSecretKey");
}

export function getLoginUid() {
  return sessionStorage.getItem("loginUid");
}

export function setSessionSecretKey(sessionSecretKey) {
  sessionStorage.setItem("sessionSecretKey", sessionSecretKey);
}

export function setLoginUid(uid) {
  sessionStorage.setItem("loginUid", String(uid));
}

export function clearAuthStorage() {
  sessionStorage.removeItem("loginMsg");
  sessionStorage.removeItem("adminType");
  sessionStorage.removeItem("pc-access-token");
  sessionStorage.removeItem("manager-web-session");
  sessionStorage.removeItem("sessionSecretKey");
  sessionStorage.removeItem("loginUid");
}
